import React, { useState } from 'react';
import { HelpCircle, ChevronDown } from 'lucide-react';

export default function FAQSection() {
  const faqs = [
    {
      question: 'What should I bring to my first yoga class?',
      answer:
        'Just bring yourself and comfortable clothing! We provide yoga mats, blocks, and other props. If you have your own mat, feel free to bring it.'
    },
    {
      question: 'Do you offer classes for complete beginners?',
      answer:
        'Absolutely! We have beginner-friendly classes and offer modifications for all poses. Our instructors provide personalized guidance to ensure you feel comfortable.'
    },
    {
      question: 'Can I try a class before committing to a membership?',
      answer:
        'Yes! We offer a free trial class for new students. You can also purchase day passes to experience different classes before choosing a membership plan.'
    },
    {
      question: 'Do you have corporate wellness programs?',
      answer:
        'Yes, we offer customized corporate wellness programs including on-site classes, stress management workshops, and employee wellness consultations.'
    }
  ];

  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(prev => (prev === index ? null : index));
  };

  return (
    <div className="bg-slate-50/50 border-t border-slate-100 py-14 lg:py-18">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wider bg-emerald-50 text-emerald-800 border border-emerald-200/70 mb-3 shadow-2xs">
            <HelpCircle size={14} className="text-emerald-600" />
            <span>Common Queries</span>
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-slate-900 tracking-tight mb-2">
            Frequently Asked Questions
          </h2>
          <p className="text-sm sm:text-base text-slate-500 max-w-xl mx-auto">
            Quick answers to common questions about our wellness classes and services.
          </p>
        </div>

        <div className="space-y-3.5">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={index}
                className="rounded-2xl border border-slate-200/80 bg-white overflow-hidden shadow-xs hover:shadow-sm transition-all"
              >
                <button
                  type="button"
                  onClick={() => toggleFAQ(index)}
                  className="w-full flex items-center justify-between p-5 sm:p-6 text-left cursor-pointer transition-colors hover:bg-slate-50/60"
                  aria-expanded={isOpen}
                >
                  <h3 className="text-sm sm:text-base font-bold text-slate-900 pr-4">
                    {faq.question}
                  </h3>
                  <div
                    className={`w-7 h-7 rounded-full bg-slate-100 text-slate-600 flex items-center justify-center shrink-0 transition-transform duration-200 ${
                      isOpen ? 'rotate-180 bg-emerald-50 text-emerald-700' : ''
                    }`}
                  >
                    <ChevronDown size={16} />
                  </div>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 sm:px-6 sm:pb-6 pt-0 text-xs sm:text-sm text-slate-600 leading-relaxed border-t border-slate-100/80">
                    <p className="mt-3">{faq.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
